import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class ContractorService {

  constructor(
              private http: HttpClient, 
              private global: GlobalDataService
              ) { }


   getContractor(page: number = 0) {
         let url = "";
         if(page){
           url = "?page="+page;
         }
        return this.http.get(this.global.httpUrl+"contractors"+url);
    }

    
   getContractorList() {
       return this.http.get(this.global.httpUrl+"contractors/list?active=1");
   }
    getContacrtorByFilter(filter: any[],page:number=0){
        let url = "";

        if(page){
            url = "page="+page + "&";
        }

        for (var item of filter) {
            url += item.name + "=" + item.value + "&";
        }

        url = url.substring(0,url.length-1);

        return this.http.get(this.global.httpUrl + "contractors?" + url);
    }

    getContractorById(id: any) {
        return this.http.get(this.global.httpUrl+"contractors/"+id);
    }

   createContractor(data: any){
        return this.http.post(this.global.httpUrl+"contractors", data); 
    }

   updateContractor(data: any,id: any){     
        return this.http.put(this.global.httpUrl+"contractors/"+id, data); 
    } 


}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/contractors/contractor.service.ts